import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import ModaTitle from './ModalTitle';

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiDialog-paperScrollPaper": {
            minWidth: '25rem',
            minHeight: '10rem',
            background: theme.palette.background.default,
            zIndex: 9999999,
        },
        "& .MuiPaper-rounded": {
            borderRadius: "8px"
        },
        // "&": {
        // }

        [theme.breakpoints.down('xs')]: {
            "& .MuiDialog-paperScrollPaper": {
                minWidth: '90%',
            }
        }
    },
    content: {
        padding: "0.5rem 1rem 1rem 1rem",
    }
}));

const AppModal = ({
    children,
    onClose,
    open,
    className,
    title,
    hideClose,
    textAscent,
    ActionComponent,
    showActions = true,
    fullWidth = false,
    maxWidth = 'xl',
    modaTitleProps = {},
    ...props
}) => {

    const classes = useStyles();

    return (

        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={onClose}
            aria-labelledby="modal"
            className={clsx(classes.root, className)}
            disableScrollLock
            {...props}
        >
            <ModaTitle ascent={textAscent} onClose={onClose} {...modaTitleProps}>
                {title}
            </ModaTitle>
            {
                children && (
                    <DialogContent className={classes.content}>{children}</DialogContent>
                )
            }
            {
                showActions && (

                    <DialogActions>
                        {!hideClose && (
                            <Button onClick={onClose} color="primary">
                                Close
                            </Button>
                        )}
                        {ActionComponent}
                    </DialogActions>
                )
            }
        </Dialog>
    );
}

AppModal.propTypes = {

}

export default AppModal

